module.exports = __webpack_public_path__ + "static/img/buyers-hero.17e55b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buyers-hero.jpg
// module id = uFIq
// module chunks = 1